<template>
  <el-dialog v-model="visible" title="设备转移" width="500px" @close="handleClose">
    <div class="transfer-content">
      <div class="form-item">
        <label>选择云手机</label>
        <div class="selected-phones">
          <el-tag v-for="phone in selectedPhones" :key="phone.id" type="primary" style="margin-right: 10px;">
            {{ phone.instance_name || `云机${phone.id}` }}
          </el-tag>
        </div>
      </div>
      <div class="form-item">
        <label>请输入接受方账号</label>
        <el-input v-model="toUser" placeholder="手机号/用户名" clearable />
      </div>
      <div class="form-item agreement">
        <el-checkbox v-model="agreedToTerms" />
        <span>我已阅读并同意《锦田云手机使用权转移协议》</span>
      </div>
      <div class="explain-text">
        <div>转移说明:</div>
        <div>1.在进行设备转移操作时，设备剩余时间需要大于24小时</div>
        <div>2.每台设备 24小时内只能进行1次转移操作</div>
        <div>3.由于设备转移操作不可逆，在转移前请确认账号信息准确</div>
        <div>注意:设备转移是转移你的设备到你其他的账号，而不是转移设备的时间!请合理且合法利用设备转移功能!</div>
      </div>
    </div>
    <template #footer>
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :disabled="!agreedToTerms" @click="handleConfirm">确认转移</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { ElMessage } from 'element-plus';
import request from '@/utils';

const visible = ref(false);
const toUser = ref('');
const agreedToTerms = ref(false);
const selectedPhones = ref<any[]>([]);

const show = (phones: any[]) => {
  selectedPhones.value = phones;
  visible.value = true;
  toUser.value = '';
  agreedToTerms.value = false;
};

const handleClose = () => {
  visible.value = false;
};

const handleConfirm = async () => {
  if (!agreedToTerms.value) {
    ElMessage.warning('请勾选锦田云手机使用权转移协议');
    return;
  }
  if (!toUser.value) {
    ElMessage.warning('请输入接受方账号');
    return;
  }
  try {
    const idArray = selectedPhones.value.map(item => item.id);
    await request.post('/instances/transfer', {
      instance_use_id: idArray,
      to_user: toUser.value
    });
    ElMessage.success('云手机转移成功');
    handleClose();
  } catch (error) {
    console.error('转移失败:', error);
  }
};

defineExpose({ show });
</script>

<style scoped>
.transfer-content {
  padding: 10px 0;
}

.form-item {
  margin-bottom: 20px;
}

.form-item label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #606266;
}

.selected-phones {
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 4px;
  min-height: 40px;
}

.agreement {
  display: flex;
  align-items: center;
  gap: 8px;
}

.agreement span {
  font-size: 14px;
  color: #0575ff;
}

.explain-text {
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  font-size: 12px;
  color: #909399;
  line-height: 1.6;
}

.explain-text > div:first-child {
  font-weight: bold;
  margin-bottom: 5px;
}
</style>
